import { selectOrganizationPlanId } from '@carboncopyco/data';
import type {
  IUser,
  PermissionAction,
  PermissionKey,
} from '@carboncopyco/types';
import constate from 'constate';
import merge from 'lodash-es/merge';
import { useSelector } from 'react-redux';
import { planToPermission } from '../../consts';

type UsePermissionsProps = Required<Pick<IUser, 'role' | 'rolesToPermissions'>>;

const usePermissions = ({ role, rolesToPermissions }: UsePermissionsProps) => {
  const planId = useSelector(selectOrganizationPlanId);
  const lowerCasePlanId = planId?.toLowerCase();
  const getPermissions = (
    permissionsKey: PermissionKey,
    action: keyof typeof PermissionAction
  ) => {
    const roleToPermission = merge(
      {},
      rolesToPermissions[role],
      planToPermission[lowerCasePlanId][role]
    );

    return roleToPermission[permissionsKey]?.[action] || false;
  };
  return { getPermissions };
};

export const [PermissionsProvider, usePermissionsContext] =
  constate(usePermissions);
